import type { ValueOf } from '@vy/utils';

export const BOOLEAN_FLAGS = Object.freeze({
  ENABLED: 'enabled',
  DISABLED: 'disabled',
});

export type BooleanFlag = ValueOf<typeof BOOLEAN_FLAGS>;

export function getFlagFromStatus(status?: boolean): BooleanFlag {
  return status ? BOOLEAN_FLAGS.ENABLED : BOOLEAN_FLAGS.DISABLED;
}

export function getStatusByFlag(flag: BooleanFlag): boolean {
  return flag === BOOLEAN_FLAGS.ENABLED;
}
